<div class="d-flex justify-content-between">
    <h4 translate>API_USERS</h4>
    <gung-button
        classes="btn-primary"
        label="{{ 'ADD' | translate }}"
        icon="fa-solid fa-user-plus"
        [onClick]="addUser.bind(this)"
        [loading]="false"
        [disable]="false"
    />
</div>
<hr>
<lib-filter-list [configService]="config"></lib-filter-list>